<template>
  <div>
    <v-list dense>
      <v-subheader>
        Your security questions are set. Your questions are:
      </v-subheader>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in questions"
          :key="i"
          disabled
        >
          <v-list-item-content>
            <v-list-item-title v-html="item" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <div class="pt-3">
      <gg-btn color="primary" tile @click="changeQuestions">
        Change questions
      </gg-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SavedQuestions',
  props: {
    questions: {
      type: Array,
      required: true
    },
  },
  methods: {
    changeQuestions () {
      this.$emit('change')
    }
  }
}
</script>
